import {AbstractControl, ValidationErrors, ValidatorFn, Validators} from '@angular/forms';
import {DateUtils} from '@app/core/utils/date.util';
import {StringUtils} from '@app/core/utils/string.utils';
import dayjs from 'dayjs';
import {OnlyDigits_Regex} from '../constants';

export class CustomValidators {
  static minDate(mindate: string | Date | null, format = 'DD.MM.YYYY'): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (mindate == null || control.value == null) {
        return null;
      }

      const controlDate = new Date(control.value);
      const validationDate = dayjs.utc(mindate, format).toDate();
      if (!(controlDate instanceof Date) || !(validationDate instanceof Date)) {
        return null;
      }

      return controlDate < validationDate
        ? {
            mindate: {
              required: DateUtils.getDateString(validationDate),
              actual: DateUtils.getDateString(controlDate),
            },
          }
        : null;
    };
  }

  static maxDate(maxdate: string | Date | null, format = 'DD.MM.YYYY'): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (maxdate == null || control.value == null) {
        return null;
      }

      const controlDate = new Date(control.value);
      const validationDate = dayjs.utc(maxdate, format).toDate();
      if (!(controlDate instanceof Date) || !(validationDate instanceof Date)) {
        return null;
      }

      return controlDate > validationDate
        ? {
            maxdate: {
              required: DateUtils.getDateString(validationDate),
              actual: DateUtils.getDateString(controlDate),
            },
          }
        : null;
    };
  }

  static requireBothOrNeitherValidator(phoneKeyName: string, countryCodeKeyName: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const phone = control.get(phoneKeyName);
      const countryCode = control.get(countryCodeKeyName);
      if (phone && countryCode) {
        const phoneValue = phone.value as string | null | undefined;
        const countryCodeValue = countryCode.value as string | null | undefined;

        const phoneHasValue = !StringUtils.isEmpty(phoneValue) && OnlyDigits_Regex.test(phoneValue ?? '');
        const countryCodeHasValue = !StringUtils.isEmpty(countryCodeValue);
        const bothHasValue = phoneHasValue && countryCodeHasValue;
        const bothHasNoValue = StringUtils.isEmpty(phoneValue) && StringUtils.isEmpty(countryCodeValue);

        if (bothHasValue || bothHasNoValue) {
          countryCode.clearValidators();
          countryCode.setErrors(null);
          phone.clearValidators();
          phone.setErrors(null);
          return null;
        } else {
          if (phoneHasValue) {
            countryCode.setValidators([Validators.required]);
            countryCode.markAsTouched();
          } else {
            phone.setValidators([Validators.required, Validators.pattern(OnlyDigits_Regex)]);
            phone.markAsTouched();
          }
          return {
            countryCodeRequired: phoneHasValue,
            phoneRequired: countryCodeHasValue,
            phonePattern: !StringUtils.isEmpty(phoneValue) && !OnlyDigits_Regex.test(phoneValue ?? ''),
          };
        }
      }
      return null;
    };
  }

  static bloodGroup(restrictedValue: string): ValidatorFn {
    return (control: AbstractControl) => {
      return control.value === restrictedValue ? {bloodGroup: true} : null;
    };
  }

  static numberOfFetusesMulti(restrictedValue: string): ValidatorFn {
    return (control: AbstractControl) => {
      return control.value === restrictedValue ? {numberOfFetusesMulti: true} : null;
    };
  }
}
